import { http } from '../../services/http';

export const getProducts = () => {
  return dispatch => {
    http
      .get(`/furniture/data/list`)
      .then(response => {
        dispatch({
          type: 'GET_PRODUCTS_SUCCESS',
          data: response.data.result.list,
        });
      })
      .catch(err => {
        dispatch({ type: 'GET_PRODUCTS_ERROR', data: err });
      });
  };
};

export const getHandles = () => {
  return dispatch => {
    http
      .get(`/furniture/data/list/5`)
      .then(response => {
        dispatch({
          type: 'GET_HANDLES_LIST_SUCCESS',
          data: response.data.result.list,
        });
      })
      .catch(err => {
        dispatch({ type: 'GET_HANDLES_LIST_ERROR', data: err });
      });
  };
};

export const getWardrobeHulls = () => {
  return dispatch => {
    http
      .get(`/furniture/data/list/1`)
      .then(response => {
        dispatch({
          type: 'GET_WARDROBE_HULLS_SUCCESS',
          data: response.data.result.list,
        });
      })
      .catch(err => {
        dispatch({ type: 'GET_WARDROBE_HULLS_ERROR', data: err });
      });
  };
};

export const getCornerHulls = () => {
  const params = {
    typeId: [9, 10, 11],
  };

  return dispatch => {
    http
      .post(`/furniture/data/list`, params)
      .then(response => {
        dispatch({
          type: 'GET_CORNER_HULLS_SUCCESS',
          data: response.data.result.list,
        });
      })
      .catch(err => {
        dispatch({ type: 'GET_CORNER_HULLS_ERROR', data: err });
      });
  };
};

export const resetFrontsByType = () => {
  return dispatch => {
    dispatch({
      type: 'GET_FRONTS_SUCCESS',
      data: [],
    });
  };
};

export const getFrontsByType = (types, activeDimensions = false, strict = true) => {
  const params = {
    typeId: types,
    strict: strict,
  };

  if (activeDimensions) {
    params.dimensions = activeDimensions;
  }

  return dispatch => {
    http
      .post(`/furniture/data/list`, params)
      .then(response => {
        dispatch({
          type: 'GET_FRONTS_SUCCESS',
          data: response.data.result.list,
        });

        dispatch({
          type: 'GET_FRONTS_GROUP_SUCCESS',
          data: response.data.result.front_type,
        });
      })
      .catch(err => {
        dispatch({ type: 'GET_FRONTS_ERROR', data: err });
        dispatch({ type: 'GET_FRONTS_GROUP_SUCCESS', data: err });
      });
  };
};

export const getBodiesByType = (types, activeDimensions = false) => {
  const params = {
    typeId: types,
    strict: true,
  };

  if (activeDimensions) {
    params.dimensions = activeDimensions;
  }

  return dispatch => {
    http
      .post(`/furniture/data/list`, params)
      .then(response => {
        dispatch({
          type: 'GET_BODIES_COLORS_SUCCESS',
          data: response.data.result.list,
        });
      })
      .catch(err => {
        dispatch({ type: 'GET_BODIES_COLORS_ERROR', data: err });
      });
  };
};

export const getImagesByType = (type = null) => {
  const params = {};

  if (type) {
    params.typeId = type;
  }

  return dispatch => {
    return http.post(`/furniture/images`, params).then(response => {
      if (response?.data) {
        dispatch({
          type: 'GET_IMAGES_LIST_SUCCESS',
          data: response.data.result,
        });
      }

      return response;
    });
  };
};
